import { useTRPC } from "../../../../trpc/client";
import { FiltersType } from "../types/filters.type";
import { useMemo } from "react";
import { useMerchant } from "../../../../hooks/useMerchant";
import { useQuery } from "@tanstack/react-query";

export function useFetchSettlements(filters: FiltersType, cursor?: string) {
  const trpc = useTRPC();
  const { merchant } = useMerchant();

  const queryFilters = useMemo(
    () => ({
      rentalsMerchantId: merchant?.id ?? "",
      status:
        filters.status === "Procesando"
          ? "processing"
          : filters.status === "Pagado"
          ? "paid"
          : undefined,
      date:
        filters.paymentDate && filters.paymentDate.trim() !== ""
          ? filters.paymentDate
          : undefined,
      feesPostpaid:
        filters.type !== undefined ? filters.type === "Mes Vencido" : undefined,
      cursor,
    }),
    [merchant?.id, filters, cursor]
  );

  const { data, isLoading } = useQuery(
    trpc.settlements.list.queryOptions(queryFilters, {
      enabled: !!merchant?.id,
      refetchInterval: 120_000,
    })
  );

  const settlements = data?.settlements || [];
  const nextCursor = data?.cursor || undefined;
  const totalItems = settlements.length || 0;

  return {
    settlements,
    nextCursor,
    totalItems,
    isLoading,
  };
}
